import { FooterLinksResource } from "app/models/FooterLinksResource";
import { CMSResource } from "app/resources/cmsresource";
import { FooterLinksResourceEdit } from "./FooterLinksResourceEdit";

export class FooterLinksListResource extends CMSResource {
    footerLinksListResource: FooterLinksResource[];


}